import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

/**
 * Collapsible section with accordion header (section-card-toggle styles in index.css).
 *
 * @param {React.ReactNode} title - Header label (string or custom content)
 * @param {React.ReactNode} [actions] - Right-side controls (clicks do not toggle open state)
 * @param {number} [count] - Optional count badge beside the title
 * @param {boolean} [defaultOpen=false] - Initial expanded state
 */
export const SectionCard = ({
    title,
    children,
    defaultOpen = false,
    count = 0,
    actions = null,
    className = '',
    headerClassName = '',
    bodyClassName = 'p-4 border-t border-gray-200',
}) => {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    return (
        <div className={`border border-gray-200 rounded-lg overflow-hidden bg-white ${className}`}>
            <div className={`flex items-stretch ${headerClassName}`}>
                <button
                    type="button"
                    onClick={() => setIsOpen(!isOpen)}
                    aria-expanded={isOpen}
                    className="section-card-toggle flex-1 min-w-0 px-4 py-3 bg-gray-50 flex items-center justify-between hover:bg-gray-100 transition-colors"
                >
                    <div className="flex items-center gap-2 min-w-0">
                        {typeof title === 'string' ? (
                            <span className="font-medium text-gray-900 truncate">{title}</span>
                        ) : (
                            title
                        )}
                        {typeof title === 'string' && (
                            <span className="bg-gray-200 text-gray-600 text-xs px-2 py-0.5 rounded-full flex-shrink-0">
                                {count}
                            </span>
                        )}
                    </div>
                    {isOpen ? (
                        <ChevronDown className="w-4 h-4 text-gray-500 flex-shrink-0" />
                    ) : (
                        <ChevronRight className="w-4 h-4 text-gray-500 flex-shrink-0" />
                    )}
                </button>
                {actions && (
                    <div
                        className="flex items-center gap-2 flex-shrink-0 px-4 py-3 bg-gray-50 border-l border-gray-200"
                        onClick={(e) => e.stopPropagation()}
                        onKeyDown={(e) => e.stopPropagation()}
                    >
                        {actions}
                    </div>
                )}
            </div>
            {isOpen && <div className={bodyClassName}>{children}</div>}
        </div>
    );
};

export default SectionCard;
